export default __webpack_public_path__ + "static/media/g.b3136124.png";